import { Component, lazy, Suspense, useMemo, useState } from 'react';
import { Loader2, RefreshCw } from 'lucide-react';

class PageLoadBoundary extends Component {
  state = {failed: false};
  static getDerivedStateFromError() { return {failed: true}; }
  render() {
    if (!this.state.failed) return this.props.children;
    return <div className="p-6 sm:p-10 text-sm text-amber-200" role="alert" data-testid={`page-load-error-${this.props.id}`}>
      <p>{this.props.title} couldn’t finish loading.</p>
      <button type="button" onClick={this.props.retry} data-testid={`page-load-retry-${this.props.id}`}
        className="mt-4 inline-flex items-center gap-2 text-cyan-300 hover:text-white transition-colors"><RefreshCw size={16}/>Retry loading page</button>
    </div>;
  }
}

// Stable loaders live outside render; no downloads for routes the user never opens.
export const DeferredPage = ({loader, loadId, loadTitle, ...props}) => {
  const [attempt, setAttempt] = useState(0);
  // The retry epoch must create a fresh lazy promise after a failed chunk.
  const Page = useMemo(() => lazy(loader), [loader, attempt]); // eslint-disable-line react-hooks/exhaustive-deps
  return <PageLoadBoundary key={attempt} id={loadId} title={loadTitle} retry={() => setAttempt(value => value + 1)}>
    <Suspense fallback={<div className="p-6 sm:p-10 flex items-center gap-3 text-sm text-slate-400" role="status" aria-live="polite" data-testid={`page-loading-${loadId}`}>
      <Loader2 size={20} className="animate-spin"/>Loading {loadTitle}…
    </div>}><Page {...props}/></Suspense>
  </PageLoadBoundary>;
};